// src/pages/StoreItemLabels.js
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { QRCodeSVG } from 'qrcode.react';
import { useSchool } from '../hooks/useSchool';

const StoreItemLabels = () => {
  const schoolId = useSchool();
  const [items, setItems] = useState([]);
  const [searchParams] = useSearchParams();

  const idsParam = searchParams.get("ids");
  const selectedIds = idsParam ? idsParam.split(",") : [];

  useEffect(() => {
    const loadItems = async () => {
      const storeCol = schoolId
        ? collection(db, "schools", schoolId, "store")
        : collection(db, "store");
      const snap = await getDocs(storeCol);
      const all = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      const filtered = selectedIds.length
        ? all.filter((i) => selectedIds.includes(i.id))
        : all;
      setItems(filtered);
    };

    if (schoolId) loadItems();
  }, [schoolId, selectedIds]);

  const itemQR = (id) => {
    const base = window.location.origin;
    return schoolId
      ? `${base}/${schoolId}/store-mode?item=${id}`
      : `${base}/store-mode?item=${id}`;
  };

  return (
    <div className="label-print-page" style={{ padding: 16 }}>
      <button
        className="print-hide"
        style={{ marginBottom: 16 }}
        onClick={() => window.print()}
      >
        🖨️ Print Labels
      </button>

      <div
        className="label-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 12,
        }}
      >
        {items.map((item) => (
          <div
            key={item.id}
            className="label-card"
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              padding: 12,
              textAlign: "center",
              background: "white",
              pageBreakInside: "avoid",
            }}
          >
           <div style={{ fontWeight: 700, marginBottom: 8 }}>{item.name}</div>

{item.imageUrl && (
  <img
    src={item.imageUrl}
    alt={item.name}
    style={{ width: "100%", maxHeight: 100, objectFit: "cover", marginBottom: 8 }}
  />
)}

<div style={{ fontSize: 12, marginBottom: 8 }}>
  🎟 {item.ticketCost ?? 0} tickets
</div>

<QRCodeSVG value={itemQR(item.id)} size={164} includeMargin />
          </div>
        ))}
      </div>

      {/* Print-specific styles */}
      <style>{`
        @media print {
          .print-hide { display: none !important; }
          .label-print-page { padding: 0; }
          @page { margin: 0.5in; }
        }
      `}</style>
    </div>
  );
};

export default StoreItemLabels;